import React from "react";
import FinalCTA from "../How-it-work/final-cta";

function AboutCTA() {
  return (
    <FinalCTA
      title="Pick your side of the marketplace."
      description={null}
    />
  );
}

export default AboutCTA;
